var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component-span> <div class=\"continue-button\" ng-click=\"$ctrl.click()\"> {{$ctrl.isPayButton === 'true' ? 'reservation_customer.go_pay' : 'reservation_customer.Continue' | i18next}} </div> </web-component-span>";
var id1="winresReservationButton.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationButton/winresReservationButton.html
// module id = 407
// module chunks = 2